import styled from "styled-components";


export const Panel=styled.div`
  width: 100%;
`